import styled from '@emotion/styled';
import classNames from 'classnames';

const StyledImg = styled.img`
    position: absolute;
    z-index: 4;
    height: calc(100% + 2px);
`;

const OverlayBackgroundImage = styled.div<{ bg?: string }>`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 3;

    background-image: url(${props => props.bg});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    filter: blur(8px);
    transform: scale(1.3);
`;

const DisabledOverlay = styled.div<{ bg?: string }>`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 20;
    border-radius: 12.694px;
    background:
        linear-gradient(0deg, rgba(243, 243, 243, 0.45) 0%, rgba(243, 243, 243, 0.45) 100%),
        url(${props => props.bg}) transparent 50% / contain no-repeat;
`;

const OverlayBackgroundColor = styled.div<{ bgColor?: string }>`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;

    background-color: ${({ bgColor }) => bgColor || 'rgba(0, 0, 0, 0.1)'};
`;

const OverlayContainer = styled.div<{ isLoading?: boolean; disabled?: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;

    transform: scale(100%);
    transition: all 0.2s ease-in-out;
    filter: ${({ isLoading }) => (isLoading ? 'blur(4px)' : 'none')};
    opacity: ${({ isLoading }) => (isLoading ? '0.5' : '1')};
`;

interface Props {
    bg?: string;
    isLoading?: boolean;
    showBlur?: boolean;
    bgColor?: string;
    disabled?: boolean;
    className?: string;
}

export const BackgroundOverlay = ({ bg, isLoading, showBlur = true, bgColor, disabled, className }: Props) => {
    return (
        <OverlayContainer className={classNames('BackgroundOverlay', className)} isLoading={isLoading} disabled={disabled}>
            <StyledImg src={bg} />

            {showBlur && <OverlayBackgroundImage bg={bg} />}
            {disabled && <DisabledOverlay bg={bg} />}
            <OverlayBackgroundColor bgColor={bgColor} />
        </OverlayContainer>
    );
};
